import { render } from "./limitslist.vue?vue&type=template&id=09653ef2"
import script from "./limitslist.vue?vue&type=script&lang=js"
export * from "./limitslist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__